import React, { useContext } from "react";
import { Checkbox } from "../../view/Checkbox";
import { TableContext } from "../../index";
import arrowImg from "../../_resources/img/arrow-not-fill.svg"

export const initShowChangesConfig = {
    passToFail: false,
    passToUnknown: false,
    failToPass: false,
    unknownToPass: false
}

function HighlightManagement() {

    const { config, setConfig } = useContext(TableContext);
    const { showChanges } = config;

    const onHighlightChangesClick = (fieldKey) => setConfig({
        ...config,
        showChanges: { ...showChanges, [fieldKey]: !showChanges[fieldKey] }
    });

    const imgRight = () => <img alt={'arrow-img'} src={arrowImg} color={'black'} className="oct_highlight-management" />;

    return (
        <div>
            <div className="d-flex justify-content-end mb-2 oct_highlightmanagement-margin">
                <span className="mr-2 card-title">HIGHLIGHT CHANGES</span>
            </div>
            <div className="d-flex align-items-center justify-content-end">
                <span className="mr-2 text-sm">PASS {imgRight()} FAIL</span>
                <Checkbox onClick={() => onHighlightChangesClick('passToFail')} checked={showChanges.passToFail} />

                <span className="mr-2 text-sm">PASS {imgRight()} UNKNOWN</span>
                <Checkbox onClick={() => onHighlightChangesClick('passToUnknown')} checked={showChanges.passToUnknown} />
            </div>
            <div className="d-flex align-items-center mt-2 justify-content-end">

                <span className="mr-2 text-sm">FAIL {imgRight()} PASS</span>
                <Checkbox onClick={() => onHighlightChangesClick('failToPass')} checked={showChanges.failToPass} />

                <span className="mr-2 text-sm">UNKNOWN {imgRight()} PASS</span>
                <Checkbox onClick={() => onHighlightChangesClick('unknownToPass')} checked={showChanges.unknownToPass} />
            </div>
        </div>
    )


}

export default HighlightManagement;


